import { PanelPermissionEnum } from '@data/sdk/match';
import { useAppUserStore } from '@data/storage';

export const getUserPanelPermissions = () => {
  const { user } = useAppUserStore.getState();

  const panelPermissions = user?.panelPermissions;

  const PANEL_WRITE = panelPermissions?.includes(PanelPermissionEnum.Write);
  const PANEL_FUNNEL = panelPermissions?.includes(PanelPermissionEnum.Funnel);
  const PANEL_CONTACTS = panelPermissions?.includes(PanelPermissionEnum.Contacts);

  return {
    PANEL_WRITE,
    PANEL_FUNNEL,
    PANEL_CONTACTS,
  };
};
